import React from "react"
import { XMarkIcon } from "@heroicons/react/24/outline"
import Button from "../components/ui/Button"

type FilterDrawerProps = {
  isOpen: boolean
  onClose: () => void
  title?: string
  children: React.ReactNode
  onApply: () => void
}

const FilterDrawer = ({ isOpen, onClose, title = "Filters", children, onApply }: FilterDrawerProps) => {
  return (
    <div
      className={`
        fixed inset-0 bg-black bg-opacity-25 z-50 transition-opacity
        ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}
      `}
      onClick={onClose}
    >
      <div
        className={`
          fixed bottom-0 left-0 right-0 bg-white rounded-t-xl p-4 transition-transform duration-300
          ${isOpen ? 'translate-y-0' : 'translate-y-full'}
        `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium">{title}</h3>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-4">
          {children}
        </div>

        <Button
          variant="blue"
          className="w-full mt-4"
          onClick={onApply}
        >
          Apply Filters
        </Button>
      </div>
    </div>
  )
}

export default FilterDrawer
